import CapacityHero from "@/pages/capacity/CapacityHero";
import Equipment from "@/pages/capacity/Equipment";
import AdditionalCapacity from "@/pages/capacity/AdditionalCapacity";
import CapacityCta from "@/pages/capacity/CapacityCta";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function CapacityPage() {
  usePageMeta({
    title: "Transportation Options | 30 NORTH",
    description:
      "Explore transportation options from 30 NORTH, including 53' tractor-trailer, 5-ton straight truck, and Sprinter van solutions for different freight requirements.",
    path: "/capacity",
  });

  return (
    <div data-testid="capacity-page">
      <CapacityHero />
      <Equipment />
      <AdditionalCapacity />
      <CapacityCta />
    </div>
  );
}
